export const appsAppGroupIdChartsPush = "/apps/:app_group_id/charts/push";
